import React, { ReactNode } from 'react'
import MyImage from '../myImage';

export default function NoData({ title = 'No Data Found', className = '', imagePath = '' }: { title?: string | ReactNode ; className?: string; imagePath?: string }) {
	return (
		<div
			className={`w-full my-32 rounded-lg border-b-dark font-medium text-base flex flex-col items-center justify-center ${className}`}>
			<MyImage className=' dark:invert-0 invert-[1] dark:mix-blend-normal mix-blend-luminosity' src={imagePath} height={130} alt="user"  />
			<h4 className='mt-4 text-sm md:text-xl text-center text-t-light line-clamp-2 md:w-1/2'>{title}</h4>
		</div>
	)
}
